var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtension(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66634C15 4.82539 16.4924 3.33301 18.3334 3.33301C20.1743 3.33301 21.6667 4.82539 21.6667 6.66634V9.99967H30V18.333H33.3334C35.1743 18.333 36.6667 19.8254 36.6667 21.6663C36.6667 23.5073 35.1743 24.9997 33.3334 24.9997H30V33.333H21.6667V29.9997C21.6667 28.1587 20.1743 26.6663 18.3334 26.6663C16.4924 26.6663 15 28.1587 15 29.9997V33.333H6.66669V24.9997H10C11.841 24.9997 13.3334 23.5073 13.3334 21.6663C13.3334 19.8254 11.841 18.333 10 18.333H6.66669V9.99967H15V6.66634Z",
    stroke: "#B78727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtension);
export default __webpack_public_path__ + "static/media/extension.94a0ef4e46135d0073354613385f000e.svg";
export { ForwardRef as ReactComponent };